import { StateFare } from './fare';

export interface State {
  user: StateFare.FareState;
}
